import * as React from "react";
import { BaseComponent } from "../../../../../../react-core/Html/BaseComponent";

interface ITrustMemeberDeclarationProps {}

interface ITrustMemeberDeclarationState {}

export class TrustMemeberDeclaration extends BaseComponent<
    ITrustMemeberDeclarationProps,
    ITrustMemeberDeclarationState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        return (
            <>
                <h2 className="mb-22">Confirmation</h2>

                <p className="checked-paragraph">By clicking "submit" below, I/ we confirm that</p>
                <ol className="ml-15">
                    <li className="mb-15">
                        I/ we have seen the appropriate documentation confirming the appointment of the Trustees to the
                        Trust;
                    </li>
                    <li className="mb-15">all trustees of the Trust are recorded on the platform;</li>
                    <li className="mb-15">
                        the above named Trustees have been advised that identify verification checks have been carried
                        out to comply with the Money Laundering, Terrorist Financing and Transfer of Funds (Information
                        on the Payer) Regulations 2017;
                    </li>
                    <li className="mb-15">
                        the information in relation to the Trustees which I have provided to abrdn was obtained by me;
                    </li>
                    <li className="mb-15">
                        the evidence I have obtained to verify the identity of the Trustees meets the standard evidence
                        set out within the Guidance for the UK Financial Sector issued by JMLSG; or (ii) exceeds the
                        standard evidence, in which case any further verification evidence taken are provided to abrdn;
                    </li>
                    <li className="mb-15">
                        I will retain the above mentioned evidence and provide it to abrdn immediately upon request;
                    </li>
                    <li className="mb-15">
                        I have not used the source of funds as evidence to verify the identity of the Trustees; and any
                        follow-up action required regarding the tax residency self-certification of the Trustees has
                        been completed (where applicable).
                    </li>
                    <p>
                        Important note: You must not add the Trustee to the platform if you cannot verify the Trustee's
                        identity.
                    </p>
                </ol>
            </>
        );
    }
}
